import type { DocMigration } from "../docMigration";

const elevationReferenceFrames = ["ELEVATION_FRONT", "ELEVATION_BACK", "ELEVATION_LEFT", "ELEVATION_RIGHT"];

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_343: DocMigration = {
  maxSchemaVersion: "0.0.343",
  description: "Set parentId for elevation view annotations previously derived by referenceFrame",
  apply(json: any) {
    for (const id in json.annotation) {
      const annotation = json.annotation[id];

      if (annotation.parentId) {
        continue;
      }

      if (!annotation.referenceFrame || !elevationReferenceFrames.includes(annotation.referenceFrame)) {
        continue;
      }

      let elevationView;

      switch (annotation.referenceFrame) {
        case "ELEVATION_FRONT":
          elevationView = Object.values(json.elevationViews).find((view: any) => view.referenceFrame === "FRONT");
          break;
        case "ELEVATION_BACK":
          elevationView = Object.values(json.elevationViews).find((view: any) => view.referenceFrame === "BACK");
          break;
        case "ELEVATION_LEFT":
          elevationView = Object.values(json.elevationViews).find((view: any) => view.referenceFrame === "LEFT");
          break;
        case "ELEVATION_RIGHT":
          elevationView = Object.values(json.elevationViews).find((view: any) => view.referenceFrame === "RIGHT");
          break;
      }

      if (!elevationView) {
        continue;
      }

      annotation.parentId = elevationView.id;
    }
    return json;
  },
};

export default migration_0_0_343;
